import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import OverviewFilters from "../../components/Overview/Filters"

const Overview = () => {
    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Overview</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <OverviewFilters />
        </>
    )
}

export default Overview
